import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { VasState } from './types';
import { RootState } from '@/store/types';

const namespaced = true;

export const state: VasState = {
  shops: [],
  merchantDetails: null,
  merchantId: null,
  vasId: null,
  shopId: null,
  saleType: null,
  shippingAddressPlace: null,
  customerDetails: null,
  selectedTimeslot: null,
  shopMenu: null,
  merchantShopDetails: null
};

export const vasState: Module<VasState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};